import { Component, OnInit } from '@angular/core';
import { PurchaseInvoiceService } from 'app/shared/services/purchase-invoice.service';
import { SupplierService} from 'app/shared/services/supplier.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-purchase-report',
  templateUrl: './purchase-report.component.html',
  styleUrls: ['./purchase-report.component.css']
})
export class PurchaseReportComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>

  fromDate : Date;
  toDate : Date;
  selectSupplier=null;
  isDark: boolean = false;

  supplierList : any[];
  purchaseList : any[]=[];
  filteredPurchaseList : any[]=[];


  constructor(
              private router : Router, 
              private purchaseInvoiceService: PurchaseInvoiceService,
              private supplierService : SupplierService,
              private themeService: NbThemeService,
              private decimalPipe: DecimalPipe
             )
              {
                this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

              }

    ngOnInit() {  
      this.getPurchasedItems();    
      this.getSupplierList();
      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
         });
    }

    getSupplierList(){
      this.supplierService.getAll()
       .subscribe(
          (data) => {
                      this.supplierList = data.filter((el)=>{
                        return el.Status !=="Deactivated" && 
                        el.SupName.toLowerCase() !=="production";
                      });             
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }

    getPurchasedItems(){
      this.purchaseInvoiceService.getAllItems()
       .subscribe(
          (data) => {
                    this.purchaseList = data.map(obj => obj.Type ==='Debit Note' ? {...obj,Qty : (obj.Qty*-1)} : obj); 
                    this.filteredPurchaseList=  this.purchaseList;                       
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });          
       }


     getTotalCost(){
      return this.filteredPurchaseList.map(item=>item.Amount).reduce((acc,value)=>acc + +value,0);
      }

      getTotalQty(){
        return this.filteredPurchaseList.map(item=>item.Qty).reduce((acc,value)=>acc + +value,0);
        }
    

        viewBtnClicked(){
          if(this.fromDate && this.toDate && this.selectSupplier){
              var startDate =moment(this.fromDate).format("YYYY-MM-DD");
              var endDate =moment(this.toDate).format("YYYY-MM-DD");
                  
              this.filteredPurchaseList = this.purchaseList.filter(data => {
                    var grnDate = moment(data.GrnDate).format("YYYY-MM-DD");              
                    return moment(grnDate).isBetween(startDate, endDate,undefined,'[]') && 
                    data.SupName.toLowerCase().indexOf(this.selectSupplier.trim().toLowerCase()) !==-1;
                    });
          }
          
          else if(this.fromDate && this.toDate){
            var startDate =moment(this.fromDate).format("YYYY-MM-DD");
            var endDate =moment(this.toDate).format("YYYY-MM-DD");
       
            this.filteredPurchaseList = this.purchaseList.filter(data => {
                  var grnDate= moment(data.GrnDate).format("YYYY-MM-DD");              
                  return moment(grnDate).isBetween(startDate, endDate,undefined,'[]');              
                  });
          }
  
          else if(this.selectSupplier){
            this.filteredPurchaseList = this.purchaseList.filter(data => {                         
                   return data.SupName.toLowerCase().indexOf(this.selectSupplier.trim().toLowerCase()) !==-1;            
                  });
          }
          else{
            this.filteredPurchaseList =  this.purchaseList; 
          }
  
        }


     clearBtnClicked(){
      this.fromDate = null;
      this.toDate = null;
      this.selectSupplier  = null;
      this.filteredPurchaseList =  this.purchaseList; 
     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Purchase Report', style: 'reportHeader' }, 
          { text: (this.fromDate && this.toDate) ? `${moment(this.fromDate).format("YYYY-MM-DD")} To ${moment(this.toDate).format("YYYY-MM-DD")}` : '',alignment: 'center',margin: [0, 3] }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto','auto', '*','auto', 'auto', 'auto', 'auto', 'auto',  'auto','auto'],  
                body: [  
                  ['Date','BillNo','Type', 'Supplier','ItemCode','Description','CreatedBy','UnitPrice', 'Qty','Unit', 'Amount'],
                  ...this.filteredPurchaseList.map(p => ([moment(p.GrnDate).format("YYYY-MM-DD"), p.GrnNo,p.Type, p.SupName, p.ItemCode,p.Description,p.CreatedBy,{ text : this.transformNumberFormat(p.UnitPrice), alignment: 'right'  }, { text : p.Qty,alignment: 'center'  }, p.Unit, { text: this.transformNumberFormat(p.Amount),alignment: 'right' }])),  
                  [ { text: 'Total Qty/Cost', bold: true,alignment: 'right', colSpan: 8 }, {},{},{},{},{},{},{},{ text :  this.getTotalQty(),alignment: 'center', bold : true },{}, { text :  this.transformNumberFormat(this.getTotalCost()),alignment: 'right', bold : true } ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 10],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('purchaseReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Purchase Report.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }

}

